'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';

const FlagAfAsset = ({ width, height, ...props }, ref) => /* @__PURE__ */ jsxs(
  "svg",
  {
    viewBox: "0 0 28 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width,
    height,
    ref,
    "aria-hidden": true,
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M-3.8147e-05 0H28C28 6.66667 28 13.3333 28 20C18.6667 20 9.33333 20 1.2517e-06 20C1.2517e-06 13.3333 0.000255184 6.66667 -3.8147e-05 0Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsx("path", { d: "M9.33333 0H28V20H9.33333V0Z", fill: "#1AB11F" }),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M1.2517e-06 20H9.33333V0H-3.8147e-05L1.2517e-06 20Z",
          fill: "#262626"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M9.33333 20H18.6667V0H9.33333V20Z",
          fill: "#DC0D18"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M11.3333 8.66667C11.7015 8.66667 12 8.96514 12 9.33333C12 10.0718 12.3999 10.7177 12.9982 11.0648C13.3167 11.2496 13.425 11.6576 13.2402 11.9761C13.0555 12.2945 12.6475 12.4029 12.329 12.2181C11.3365 11.6422 10.6667 10.5664 10.6667 9.33333C10.6667 8.96514 10.9651 8.66667 11.3333 8.66667ZM16.6667 8.66667C17.0349 8.66667 17.3333 8.96514 17.3333 9.33333C17.3333 10.5147 16.7183 11.552 15.794 12.1431C15.4839 12.3415 15.0716 12.2508 14.8732 11.9407C14.6748 11.6305 14.7655 11.2182 15.0757 11.0198C15.6329 10.6634 16 10.041 16 9.33333C16 8.96514 16.2985 8.66667 16.6667 8.66667Z",
          fill: "#F8ABAF"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M14 10.6667C14.7364 10.6667 15.3333 9.77124 15.3333 8.66667C15.3333 7.5621 14.7364 6.66667 14 6.66667C13.2636 6.66667 12.6667 7.5621 12.6667 8.66667C12.6667 9.77124 13.2636 10.6667 14 10.6667Z",
          fill: "white",
          fillOpacity: 0.5
        }
      )
    ]
  }
);
const VpFlagAfAsset = forwardRef(FlagAfAsset);

export { VpFlagAfAsset as default };
